import React, { Component } from "react";
import { connect } from "react-redux";
import { listEducation } from "../../actions/member/education_action";
import { universityList } from "../../actions/master-data/university_action";
import {
  getListEducation,
  getEducationError,
  getEducationPending,
} from "../../reducers/member/education_reducer";
import {
  getUniversityList,
  getUniversityListPending,
} from "../../reducers/master-data/university_reducer";
import MaterialTable from "material-table";
import PaginationComponent from "../../components/table/PaginationComponent";
import { Paper } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import DetailButtonComponent from "../../components/global-components/DetailButtonComponent";
import ContentContainer from "../../components/container/ContainerComponent";
import EducationHeader from "./EducationHeader";
import EducationModalAdd from "./EducationModalAdd";
import EducationModalDelete from "./EducationModalDelete";
import TableStatusComponent from "../../components/global-components/TableStatusComponent";

class Education extends Component {
  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    this.state = {
      id: null,
      search_text: "",
      showModalAdd: false,
      showModalDelete: false,
    };

    this.handleRefresh = this.handleRefresh.bind(this);
    this.handleShowModalAdd = this.handleShowModalAdd.bind(this);
    this.detailRecord = this.detailRecord.bind(this);
    this.handleOpenModalDelete = this.handleOpenModalDelete.bind(this);
  }

  onchange(e) {
    this.setState({ input: e.target.value });
  }

  handleRefresh(state) {
    if (state) {
      this.setState(state);
    }
    this.setState({ id: null })
    this.tableRef.current && this.tableRef.current.onQueryChange();
  }

  detailRecord(id) {
    this.props.history.push(`/admin/member-education/detail/${id}`);
  }
  handleOpenModalDelete(id) {
    this.setState({ id, modalDeleteShow: true });
  }

  handleShowModalAdd() {
    this.setState({ showModalAdd: true });
  }

  componentDidMount() {
    const { universityList } = this.props;
    const param = {
      page: 1,
      length: 999,
    };
    universityList(param);
    const url = window.location.href;
    const ID = url.substring(url.lastIndexOf('/') + 1);
    const isID = url.substring(url.lastIndexOf('/') + 1) !== "member-education";
    if (isID && this.state.id === null) {
      this.setState({ id: ID })
    }
  }

  render() {
    const { listEducation, listEducation_data } = this.props;
    const { search_text, showModalAdd, modalDeleteShow, id } = this.state;
    let data = [];
    let records_total = 0;
    if (listEducation_data) {
      data = listEducation_data.data;
      records_total = listEducation_data.records_total;
    }
    const windowWidth = window.innerWidth;
    const pageLength = windowWidth > 768 ? 10 : 5;
    const mobileWhiteSpace = windowWidth > 768 ? { whiteSpace: 'normal' } : { whiteSpace: 'nowrap' };
    return (
      <ContentContainer>
        <EducationHeader
          handleRefresh={this.handleRefresh}
          handleShowModalAdd={this.handleShowModalAdd}
        />
        <EducationModalAdd
          show={showModalAdd}
          onHide={() => this.setState({ showModalAdd: false })}
          handleRefresh={this.handleRefresh}
        />
        <EducationModalDelete
          id={id}
          show={modalDeleteShow}
          onHide={() => this.setState({ modalDeleteShow: false })}
          handleRefresh={this.handleRefresh}
        />
        <MaterialTable
          tableRef={this.tableRef}
          columns={[
            {
              title: "No",
              field: "no",
              width: 20,
              headerStyle: {
                paddingLeft: 40,
              },
              cellStyle: {
                paddingLeft: 40,
              },
            },
            {
              title: "Member",
              field: "member_data.name",
              cellStyle: mobileWhiteSpace
            },
            {
              title: "ID PABOI",
              field: "member_data.member_profile.paboi_id",
              cellStyle: mobileWhiteSpace
            },
            {
              title: "Universitas",
              field: "university_to",
              cellStyle: mobileWhiteSpace
            },
            {
              title: "jenjang Pendidikan",
              field: "education_stage",
              cellStyle: mobileWhiteSpace
            },
            {
              title: "Gelar",
              field: "degree",
              cellStyle: mobileWhiteSpace
            },
            {
              title: "Tahun Lulus",
              field: "graduated",
              cellStyle: mobileWhiteSpace
            },
            {
              title: "Status",
              field: "status",
              render: ({ status }) => {
                return (
                  <TableStatusComponent
                    status={
                      status === 0
                        ? "Baru"
                        : status === 1
                          ? "Terverifikasi"
                          : "Ditolak"
                    }
                  />
                );
              },
            },
            {
              title: "",
              render: ({ id }) => {
                return (
                  <DetailButtonComponent>
                    <MenuItem onClick={() => this.detailRecord(id)}>
                      Detail
                    </MenuItem>
                    {/* <MenuItem onClick={() => this.handleOpenModalDelete(id)}>
                      Delete
                    </MenuItem> */}
                  </DetailButtonComponent>
                );
              },
            },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let param = {
                page: query.page + 1,
                length: pageLength,
                search_text: search_text,
                id: this.state.id
              };
              listEducation(param, resolve, reject);
            })
          }
          options={{
            pageSize: pageLength,
            paginationType: "stepped",
            pageSizeOptions: [],
            headerStyle: {
              backgroundColor: "#F8F9FB",
            },
          }}
          localization={{
            body: {
              emptyDataSourceMessage: "Tidak ada data",
            },
          }}
          components={{
            Toolbar: () => <div />,
            Container: (props) => <Paper {...props} elevation={0} />,
            Pagination: (props) => (
              <PaginationComponent
                records={data.length}
                records_total={records_total}
                {...props}
              />
            ),
          }}
        />
      </ContentContainer>
    );
  }
}

function mapStateToProps({ universityList, listEducation }) {
  return {
    listEducation_data: getListEducation(listEducation),
    listEducation_error: getEducationError(listEducation),
    listEducation_pending: getEducationPending(listEducation),
    listUniversity_data: getUniversityList(listEducation),
    listUniversity_pending: getUniversityListPending(listEducation),
  };
}

export default connect(mapStateToProps, {
  listEducation,
  universityList,
})(Education);
